import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  categories: []
}

const mutations = {  
  SET_CATEGORIES (state, payload) {
    state.categories = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  categoriesList: (context, id) => {
    return Vue.http.get(`${env.API}/api/category`)    
      .then((response) => {        
        context.commit('SET_CATEGORIES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getCatById: (context, id) => {
    return Vue.http.get(`${env.API}/api/category/by-id/${id}`)    
      .then((response) => {                
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getCategories: (state) => state.categories
}

export const category = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/category.js